/* file description */
import React, { FC, useState, useEffect } from 'react';
import { getModuleRecordListCache } from '@/common/asset-apis/assetModel';

import { ReferenceRenderProps } from './type';
import { COLUMN_FROM } from '../../effects/consts';

export const ReferenceRender: FC<ReferenceRenderProps> = ({
  field,
  API,
  targerValue,
  rowsData,
  columnFrom,
  setViewValue,
}) => {
  const { dataKey, treeId, bindId, label, value, isBindLabel, labelBindKey, labelBindLabel, labelModule, isFilter, dataType, prefilter } = field?.bizConfig || {};
  const [renderData, setRenderData] = useState<any>('');

  const convert = (data: any) => {
    const obj: Record<any, any> = {};
    data.values && data.values.forEach((item: any) => {
      obj[item.name] = item.value;
    });
    return obj;
  };

  useEffect(() => {
    if (!targerValue) {
      return;
    }
    const fieldDataList: any[] = [];
    if (columnFrom === COLUMN_FROM.TABLE) {
      rowsData?.forEach((item: any) => {
        if (item[field.name]) {
          fieldDataList.push(item[field.name]);
        }
      });
    } else {
      fieldDataList.push(targerValue);
    }
    if (fieldDataList.length < 1) {
      return;
    }
    const targetSql = fieldDataList.map((fV) => `'${fV}'`).join(',');
    const params: Record<any, any> = {
      moduleID: dataKey,
      namespaceID: treeId,
      limit: 3000,
      filter: `${value} in (${targetSql})`,
    };
    getModuleRecordListCache(API?.FetchAPI, params.namespaceID, params.moduleID, params).then((res: any) => {
      const { set = [] } = res || {};
      const listData = set.map((r: any) => convert(r));
      if (isBindLabel && labelModule && labelBindKey) {
        const binditem = listData?.find((item: Record<any, any>) => item[value] === targerValue) || {};
        getModuleRecordListCache(API?.FetchAPI, bindId, labelModule,
          {
            moduleID: labelModule,
            namespaceID: bindId || treeId,
            limit: 100,
            filter: `${labelBindKey} = '${binditem[label]}'`,
          }).then(response => {
          const bindData = response.set?.[0]?.values || [];
          const findDictItem = bindData?.find((item: Record<any, any>) => item.name === labelBindLabel) || {};
          setRenderData(findDictItem.value || targerValue);
        });
      } else {
        const key = isBindLabel ? labelBindKey : value;
        const realLabel = isBindLabel ? labelBindLabel : label;
        const findDictItem = listData?.find((item: Record<any, any>) => item[key] === targerValue) || {};
        setRenderData(findDictItem[realLabel] || targerValue);
      }
    });
  }, [rowsData]);

  useEffect(() => {
    setViewValue(renderData);
  }, [renderData]);

  return renderData;
};
export default ReferenceRender;
